'use client';

import { useMemo, useState } from 'react';
import CalculatorInputs from './CalculatorInputs';
import ResultsDisplay from './ResultsDisplay';
import { calculateR40 } from './calculations';
import { R40Values } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  translations: ToolsTranslations['r40'];
}

export default function R40Calculator({ translations }: Props) {
  const [values, setValues] = useState<R40Values>({
    revenueGrowthPercent: 20,
    profitMarginPercent: 15,
  });

  const handleValuesChange = (field: keyof R40Values, value: number | string) => {
    setValues(prev => ({ ...prev, [field]: value }));
  };

  const result = useMemo(() => calculateR40(values), [values]);

  return (
    <section id="r40-calculator" className="w-full my-12 tools">
      <div className="rounded-xl border border-gray-200 shadow-sm bg-white">
        <div className="p-6 border-b border-gray-100">
          <div className="flex items-center justify-between gap-4">
            <div>
              <h2 className="text-xl font-semibold text-blue-900">{translations.title}</h2>
              <p className="text-sm text-gray-600 mt-1">{translations.subtitle}</p>
            </div>
          </div>
        </div>
        <div className="p-6 space-y-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <CalculatorInputs values={values} onValuesChange={handleValuesChange} translations={translations} />
            <ResultsDisplay result={result} translations={translations} />
          </div>
        </div>
      </div>
    </section>
  );
}


